<!-- Template -->

<template>   
    <div v-if="visible" name="modal" >
        <div class="modal modal-mask" id="modal-contact" ref="modalContact" tabindex="-1" role="dialog" aria-labelledby="modal-contact" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">

                    <!-- Header -->

                    <div class="modal-header">
                        <h3 class="modal-title">Hospital Contact</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="close">
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <!-- Body -->

                    <div class="modal-body">

                        <span v-if="contactLoading" class="spinner-border modal-loader"></span>

                        <div class="notifications-container" v-if="!contactLoading && saved">
                            <FormNotification :message="notification"/>
                            <FormNotification is-error :message="error"/>
                        </div>
                        <ValidationObserver ref="validation" v-slot="{ invalid }" v-if="!contactLoading && !saved">
                            <form>
                                <div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <ValidationProvider name="First name" vid="firstName" rules="required" v-slot="{ errors }" >
                                                    <div :class="{'is-error': errors.length }" >
                                                        <label for="firstName">First name</label>
                                                        <input autofocus type="text" id="firstName" v-model="firstName" class="w">
                                                        <div class="error-label">{{ errors[0] }}</div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <ValidationProvider name="Last name" vid="lastName" rules="required" v-slot="{ errors }" >
                                                    <div :class="{'is-error': errors.length }" >
                                                        <label for="lastName">Last name</label>
                                                        <input autofocus type="text" id="lastName" v-model="lastName" class="w">
                                                        <div class="error-label">{{ errors[0] }}</div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <ValidationProvider name="Job Title" vid="jobTitle" rules="required" v-slot="{ errors }" >
                                                    <div :class="{'is-error': errors.length }" >
                                                        <label for="jobTitle">Job title</label>
                                                        <input autofocus type="text" id="jobTitle" v-model="jobTitle" class="w">
                                                        <div class="error-label">{{ errors[0] }}</div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>

                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-6">
                                            <h4>Contact</h4>
                                            <div class="form-group">
                                                <ValidationProvider name="email" vid="email" rules="required|email" v-slot="{ errors }" >
                                                    <div :class="{'is-error': errors.length }" >
                                                        <label for="email">Email</label>
                                                        <input autofocus type="email" id="email" v-model="email" class="w" disabled="disabled">
                                                        <div class="error-label">{{ errors[0] }}</div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6 ">
                                            <div class="form-group">
                                                <ValidationProvider name="Mobile phone" vid="phoneMobile" v-slot="{ errors }" >
                                                    <div :class="{'is-error': errors.length }" >
                                                        <label for="phoneMobile">Mobile phone</label>
                                                        <input autofocus type="text" id="phoneMobile" v-model="phoneMobile" class="w">
                                                        <div class="error-label">{{ errors[0] }}</div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-6 ">
                                            <div class="form-group">
                                                <ValidationProvider name="Work phone" vid="phoneWork" v-slot="{ errors }" >
                                                    <div :class="{'is-error': errors.length }" >
                                                        <label for="phoneWork">Work phone</label>
                                                        <input autofocus type="text" id="phoneWork" v-model="phoneWork" class="w">
                                                        <div class="error-label">{{ errors[0] }}</div>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <h4>Hospitals where I work:</h4>
                                            <div class="sites-container">
                                                <div class="custom-control custom-checkbox" v-for="site in sites" :key="site.id" >
                                                    <input type="checkbox" class="custom-control-input" disabled="disabled" v-model="site.associated">
                                                    <label class="custom-control-label" :class="{current: selectedHospital == site.id}">{{site.siteName}}</label>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="submit">
                                    <div>
                                        <a @click.prevent="showFeedback" class="blue mb-2">Submit feedback regarding my information</a>
                                        <a @click.prevent="showDelete" class="red">Request Delete</a>
                                    </div>

                                    <button type="submit" class="btn-large btn-blue" :disabled="invalid || isProcessing" @click.prevent="onSave">
                                        <span v-if="!isProcessing">Save</span>
                                        <span v-if="isProcessing" class="spinner-border mt-0"></span>
                                    </button>
                                </div>                                
                            </form>
                        </ValidationObserver>

                        <div v-if="saved" class="back-to-contact-form">
                             <a @click.prevent="gotoContactForm()">Go back</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

    </div>
</template>

<!-- Script -->

<script>
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { PageMessage } from "@/models/page-message";
    import { HospitalService } from '@/services/hospital-service';
    import FormNotification from "@/components/Login/FormNotification";


    export default {
        name: 'Contact',

        components: {
            ValidationProvider,
            ValidationObserver,
            FormNotification
        },

        data() {
            return {
                contactLoading: true,
                visible: false,
                sites: [],
                firstName:'',
                lastName:'',
                jobTitle: '',
                email:'',
                phoneWork:'',
                phoneMobile:'',
                isProcessing: false,
                error: new PageMessage(),
                notification: new PageMessage(),
                contactDetails: {},
                id:null,
                selectedHospital: null,
                saved:false,
                contactForBack:null
            }
        },

        computed: {
            validator() {
                return this.$refs.validation;
            }
        },

        watch: {
			'$route' (to) {
                this.selectedHospital = to.params.hospital;
            }
        },

        created() {  
            this.selectedHospital = this.$route.params.hospital;
            this.hospitalService = new HospitalService(this.$api, this.$store);  
            
        },

        methods: {
            async show(contact) {
                this.id = contact.id;
                
                this.visible = true;
                this.email = contact.email;
                this.firstName = contact.firstName;
                this.lastName = contact.lastName;
                this.jobTitle = contact.jobTitle;
                this.phoneWork = contact.phoneWork;
                this.phoneMobile = contact.phoneMobile;

                var sites = contact.sites;
                var filteredSites = sites.filter(function (el) {
                    return el.siteName != '';
                });

                filteredSites.sort(function(a, b) {
                    var textA = a.siteName.toUpperCase();
                    var textB = b.siteName.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });

                this.sites = filteredSites;
               
                this.contactLoading = false;


                this.setContactForBackOld(contact);
            },

            close() {
                this.saved = false;
                this.visible = false;
                this.contactLoading = true;
                this.error.reset();
                this.notification.reset();
            },

            gotoContactForm(){
                this.error.reset();
                this.notification.reset();
                this.saved = false;
            },

            

            async onSave() {
                const isValid = await this.validator.validate();

                if (!isValid) return;

                this.isProcessing = true;
                this.error.reset();
                this.notification.reset();

                try {

                    this.contactDetails = await this.hospitalService.getContact(this.id);

                    var data = {
                        additionalDetails: this.contactDetails.additionalDetails,
                        email: this.email,
                        fax: this.contactDetails.fax,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        jobTitle: this.jobTitle,
                        phoneMobile: this.phoneMobile,
                        phoneWork: this.phoneWork,
                        salutation: this.contactDetails.salutation,
                        title: this.contactDetails.title
                    }

                    this.setContactForBack();
                 
                    await this.hospitalService.changeContactDetails(this.id, data);
                    this.saved = true;
                    this.notification.set("Contact data successfully changed.");
                } catch (error) {
                    this.saved = true;
                    this.error.setError(error.data.title);
                } finally {
                    this.isProcessing = false;
                }
            },

            showDelete(){
                this.visible = false;
                this.$emit('showRequestDeleteDialog');
            },

            showFeedback(){
                this.setContactForBack();
                this.visible = false;
                this.$emit('showFeedbackDialog', this.contactForBack);
            },

            setContactForBack(){
                this.contactForBack = {
                    email: this.email,
                    firstName: this.firstName,
                    id: this.id,
                    jobTitle: this.jobTitle,
                    lastName: this.lastName,
                    phoneMobile: this.phoneMobile,
                    phoneWork: this.phoneWork,
                    salutation: this.contactDetails.salutation,
                    sites: this.sites,
                    title: this.contactDetails.title
                }

            },

            setContactForBackOld(contact){
                this.contactForBack = contact;
            }
        }
    }
</script>